var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1040_14591)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1040_14591",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92902 14.1806C8.77354 14.1816 9.60994 14.0158 10.3902 13.6926C11.1704 13.3695 11.879 12.8953 12.4754 12.2973C13.0734 11.7009 13.5476 10.9923 13.8707 10.2121C14.1939 9.43184 14.3597 8.59543 14.3587 7.75092C14.3597 6.90642 14.1939 6.07002 13.8707 5.2898C13.5475 4.50958 13.0733 3.80092 12.4754 3.20453C11.879 2.60659 11.1704 2.13239 10.3902 1.8092C9.60994 1.48601 8.77354 1.3202 7.92902 1.32129C7.08452 1.32022 6.24812 1.48604 5.4679 1.80923C4.68768 2.13242 3.97902 2.6066 3.38263 3.20453C2.7847 3.80092 2.31052 4.50958 1.98733 5.2898C1.66414 6.07002 1.49832 6.90642 1.4994 7.75092C1.4983 8.59543 1.66411 9.43184 1.9873 10.2121C2.31049 10.9923 2.78469 11.7009 3.38263 12.2973C3.97902 12.8952 4.68768 13.3694 5.4679 13.6926C6.24812 14.0158 7.08452 14.1816 7.92902 14.1806Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.92889,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35712 7.75018L7.28601 9.67907L11.1438 5.82129",
    stroke: "black",
    strokeWidth: 1.92889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1040_14591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.213379 0.0371094H15.6445V15.4682H0.213379V0.0371094Z",
    fill: "#008B44"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1040_14591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4311,
    height: 15.4311,
    fill: "white",
    transform: "translate(0.213379 0.0371094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.74dc64a14e752ce35fde15519ea14bbd.svg";
export { ForwardRef as ReactComponent };